import React from 'react'
import { FormattedMessage, defineMessages } from 'react-intl'

import { intl } from 'common/components/l10n/IntlGlobalProvider'

export const ticketSearch = (<FormattedMessage
  id="SearchBar.ticketSearch"
  description="Label for ticket search box"
  defaultMessage="Ticket search"
/>)

export const travelDatesMsg = (<FormattedMessage
  id="SearchBar.travelDates"
  description="Label for travel date selection"
  defaultMessage="Travel dates"
/>)

export const passengersDiscountsLabelMsg = (<FormattedMessage
  id="SearchBar.passengersDiscountsLabel"
  description="Label for passenger and discount card selection"
  defaultMessage="Passengers and discount cards"
/>)

export const returnTicketMsg = (<FormattedMessage
  id="SearchBar.returnTicket"
  description="User clicks this label to search for return tickets"
  defaultMessage="Return ticket"
/>)

export const oneWayTicketMsg = (<FormattedMessage
  id="SearchBar.onewayTicket"
  description="User clicks this label to search for one-way tickets"
  defaultMessage="One-way"
/>)

export const passengerMsg = (<FormattedMessage
  id="SearchBar.passenger"
  description="Label for one passenger"
  defaultMessage="1 passenger"
/>)

export const getMultiplePassengersMsg = (numPassengers) => (<FormattedMessage
  id="SearchBar.multiplePassenger"
  description="Label for multiple passengers"
  defaultMessage="{numPassengers} passengers"
  values={{ numPassengers }}
/>)

export const pastErrorMsg = (<FormattedMessage
  id="SearchBar.pastError"
  description="Message shown when user selects a date in the past"
  defaultMessage="This date is before today"
/>)

export const noReturnSelectedMsg = (<FormattedMessage
  id="SearchBar.noReturnError"
  description="Message shown when user hasn't selected a date for their return ticket"
  defaultMessage="You must select a return date"
/>)

export const originMissingMsg = (<FormattedMessage
  id="SearchBar.noOrigin"
  description="Message shown when user hasn't entered an origin"
  defaultMessage="Enter a starting location"
/>)

export const destinationMissingMsg = (<FormattedMessage
  id="SearchBar.noDestination"
  description="Message shown when user hasn't entered a destination"
  defaultMessage="Enter a destination"
/>)

export const agesRequiredMsg = (<FormattedMessage
  id="SearchBar.agesRequired "
  description="Message shown when user hasn't entered required passenger ages"
  defaultMessage="Ages required"
/>)

export const updateMsg = (<FormattedMessage
  id="SearchBar.update"
  description="Label for button to update search parameters"
  defaultMessage="UPDATE"
/>)

export const journeyMsg = (origin, destination) => (<FormattedMessage
  id="SearchBar.journey"
  description="Summary of the journey origin and destination"
  defaultMessage="{origin} to {destination}"
  values={{ origin, destination }}
/>)

export const locationOriginPlaceholderMsg = () => {
  const messages = defineMessages({
    locationOriginPlaceholder: {
      id: 'SearchBar.location.origin',
      description: 'Placeholder text for location origin input',
      defaultMessage: 'Enter an origin',
    },
  })
  return intl.formatMessage(messages.locationOriginPlaceholder)
}

export const locationDestPlaceholderMsg = () => {
  const messages = defineMessages({
    locationDestPlaceholder: {
      id: 'SearchBar.location.destination',
      description: 'Placeholder text for location destination input',
      defaultMessage: 'Enter a destination',
    },
  })
  return intl.formatMessage(messages.locationDestPlaceholder)
}

export const addReturnTicketMsg = (<FormattedMessage
  id="SearchBar.addReturnTicket"
  description="Label for add return ticket button"
  defaultMessage="Add return"
/>)
